<template>
  <!-- The two columns of a details page; a card marked `full-size` spans both -->
  <div class="details-grid">
    <slot />
  </div>
</template>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--t-spacing-sm);

  :slotted(.full-size) {
    grid-column: 1 / -1;
  }

  @include mobile {
    grid-template-columns: 1fr;

    :slotted(.full-size) {
      overflow: hidden;
    }
  }
}
</style>
